export function pushMatomoEvent(event: string, action: string) {
  const matomo = globalThis as typeof globalThis & {
    _mtm?: Array<Record<string, unknown>>
  }

  matomo._mtm ??= []
  matomo._mtm.push({ event, action })
}
